import React from "react";
// import FastTextArea from "components/FormElements/FastTextArea";
// import CodeEditor from "@uiw/react-textarea-code-editor";
import { Field, useField } from "formik";

function JsonMetaProperty(props) {
    const [field] = useField(props);
    return (
        <Field name={field.name}>
            {({ field }) => (
                <div className="overflow-auto rounded-md border border-gray-300 bg-white p-3 shadow-sm">
                    <pre>{JSON.stringify(field.value, null, 2)}</pre>
                </div>
            )}
        </Field>
    );
}

export default JsonMetaProperty;

export const Property = JsonMetaProperty;

export const Label = "JSON Editor";
